import { DispenseIntervalDialog } from '@/components/products/refill/DispenseIntervalDialog';
import { Alert, AlertTitle, Box, Typography, ViewObserver } from '@montugroup/design-system';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import LockClock from '@mui/icons-material/LockClock';
import { useState } from 'react';
import { StyledLink } from '../order-history-card/OrderHistoryCard.styles';

type PharmacyAllocationDispenseIntervalAlertProps = {
  reorderDate?: string;
};

export const PharmacyAllocationDispenseIntervalAlert = (props: PharmacyAllocationDispenseIntervalAlertProps) => {
  const { reorderDate } = props;
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleLearnMoreClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Box data-dd-privacy="allow">
        <ViewObserver id="dispense-interval-alert-refill-pharmacy-page">
          <Alert severity="info" icon={<LockClock />}>
            <AlertTitle>
              This order will process on or after <strong>{reorderDate}</strong>
            </AlertTitle>
            <Typography variant="body2">One or more medications are on dispense interval.</Typography>
            <StyledLink
              variant="body2"
              fontWeight="fontWeightMedium"
              onClick={handleLearnMoreClick}
              id="dispense-interval-alert-refill-pharmacy-page-link"
            >
              Learn more about Dispense Interval <InfoOutlined fontSize="small" sx={{ ml: 0.5 }} />
            </StyledLink>
          </Alert>
        </ViewObserver>
      </Box>
      <DispenseIntervalDialog dialogOpen={dialogOpen} handleCloseDialog={handleCloseDialog} />
    </>
  );
};
